<!-- eslint-disable -->
<img class="object-cover w-full h-full" *ngIf="avatar" [src]="avatar" />
<div
  class="flex items-center justify-center w-full h-full rounded overflow-hidden uppercase text-8xl font-bold leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200"
  *ngIf="!avatar"
>
  {{ name.charAt(0) }} <span *ngIf="secondName">{{ secondName.charAt(0) }}</span>
</div>
